export default "__VITE_ASSET__D85T7oBo__"